import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import api from 'brighteon/api';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default @injectIntl
class NotificationsOtherBoostedAccountsModal extends React.PureComponent {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    notification: ImmutablePropTypes.map,
  };

  state = {
    boostedAccounts: [],
  }

  componentDidMount() {
    this.getBoostedAccounts();
  }

  getBoostedAccounts = () => {
    const { notification } = this.props;
    api().get(`/api/v1/notifications/${notification.get('id')}/other_boosted_accounts`)
      .then(({ data }) => {
        this.setState({
          boostedAccounts: data,
        });
      })
      .catch(err => {
        console.error(err);
      });
  }

  handleCancel = () => {
    this.props.onClose();
  }

  render() {
    const { boostedAccounts } = this.state;

    return (
      <div className='modal-root__modal favourites-modal'>
        <div className='favourites-modal__container'>
          <div className='favourites-modal__header'>
            <div className='d-flex justify-content-space-between'>
              <span>Other boosters</span>
              <span>
                <i
                  className='fa fa-times favourites-modal__close'
                  onClick={this.handleCancel}
                  role='button' tabIndex={0}
                />
              </span>
            </div>
          </div>
          <div className='favourites-modal__body'>
            {boostedAccounts.map(boostedAccount => (
              <a
                href={boostedAccount.url}
                key={boostedAccount.id}
                className='favourites-modal__favourite-item'
              >
                <div
                  className='d-flex'
                >
                  <div
                    className='favourites-modal__favourite-avatar mr2'
                    style={{
                      backgroundImage: `url(${boostedAccount.avatar})`,
                    }}
                  />
                  <strong>
                    {boostedAccount.username}
                  </strong>
                  <span> </span>
                  <span>
                    @{boostedAccount.acct}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

}
